<script>
import axios from "axios";

const default_gatway_addr = "http://swt.js/open/apigw/";
const author_addr = "http://swt.js/user/passport/";
const AppId = "1048576-139264";
const AppSecret = "E6023D7296349C64D8A4FBC1BFA22DEB";
const grant_type = 'client_credential';

//移动一张网域名地址
const moveNetBaseAddr = 'http://50.16.195.197:38080/';

//授权令牌
let author_token = "";

//获取授权
let result = {};
// const res =axios.get(author_addr, {grant_type:grant_type,appid:AppId,appsecret:AppSecret})
//   .then(function (res) {
//     const { data } = res;
//     result = data;
//     if(data.errCode == 0)
//     {
//       author_token = data.data.appToken;
//       localStorage.setItem('author_token',author_token);
//     }
//   })
//   .catch(function (err) {
//     console.log(err);
//   });
// console.log('token result :');
// console.log(result);

const log = function (t) {
  console.log(t);
};

export default {
  default_gatway_addr,
  author_addr,
  AppId,
  AppSecret,
  author_token,
  moveNetBaseAddr,
  /**数字千分分割 */
  ThousandSplit(num) {
    var numStr = num.toString().trim();
    var numArr = numStr.split("").reverse();
    //log(numArr);
    var targetNumStr = [];
    for (var i = 0; i < numArr.length; i++) {
      var res = (i + 1) % 3;
      //log(res);
      if (res == 0) {
        targetNumStr.push(numArr[i]);
        targetNumStr.push(",");
      } else {
        targetNumStr.push(numArr[i]);
      }
    }

    var targetNumStrs = targetNumStr.reverse().join("");
    if (targetNumStrs.startsWith(",")) {
      targetNumStrs = targetNumStrs.substring(1);
    }
    return targetNumStrs;
  },
  //获取当前时间
  getCurrentTime() {
      var sysTimes = {};
      var d = new Date();
      var weekInfo = d.getDay();
      switch (weekInfo) {
        case 0:
          sysTimes.week = "星期日";
          break;
        case 1:
          sysTimes.week = "星期一";
          break;
        case 2:
          sysTimes.week = "星期二";
          break;
        case 3:
          sysTimes.week = "星期三";
          break;
        case 4:
          sysTimes.week = "星期四";
          break;
        case 5:
          sysTimes.week = "星期五";
          break;
        case 6:
          sysTimes.week = "星期六";
          break;
      }

      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      sysTimes.date =
        year +
        "." +
        (month >= 10 ? month : "0" + month) +
        "." +
        (day >= 10 ? day : "0" + day);

      var hour = d.getHours();
      var minute = d.getMinutes();
      var second = d.getSeconds();
      sysTimes.time =
        (hour >= 10 ? hour : "0" + hour) +
        ":" +
        (minute >= 10 ? minute : "0" + minute) 
        // +
        // ":" +
        // (second >= 10 ? second : "0" + second);

      return sysTimes;
  },
  //获取当前气温
  getNowWeather(city){

  }
};
</script>
